// filepath: x:\Apps\RevenueCyclePlatform\PSN.Clients\RevCycleWeb\src\services\ticketEasyService\commands\approval\TicketRejectCommand.ts
export class TicketRejectCommand {
  ticketId: string;
  rejector: string;
  rejectorEmail: string;
  comments: string;

  constructor(params: {
    ticketId: string;
    rejector: string;
    rejectorEmail: string;
    comments: string;
  }) {
    this.ticketId = params.ticketId;
    this.rejector = params.rejector;
    this.rejectorEmail = params.rejectorEmail;
    this.comments = params.comments;
  }
}